


































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { ticketClient } from "@/api/index";
import {
  GetBasicLoadAttrsReq,
  GetLoadAttrsReq,
  SaveLoadAttrReq,
  LoadAttrItem,
  GetUserAttrsOptionReq
} from "@/pbjs/external/ticket/ticket_pb";
import { timeFormat } from "@/utils/index.ts";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, handleResponse, setPage } from "@/utils/request";
import { setMetaData } from "@/utils/index";

@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private ruleForm: any = {
    name: "",
    desc: "",
    loadType: "",
    value: "",
    userGroupValue: null,
    formulaCoefficient: null
  };
  @Provide() private token: any;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private filterText: string = "";
  @Provide() private isShowNewLoadAttr: boolean = false;
  @Provide() private userId: string | null = "";
  @Provide() private loadTypeOptions: any = [
    { value: 1, name: "固定数值" },
    { value: 2, name: "公式" },
    { value: 3, name: "百分比" }
  ];
  @Provide() private formulaOptions: any = [];
  @Provide() private isEdit: boolean = false;
  @Provide() private onEditRow: any = {};
  @Provide() private rules: any = {
    name: [{ required: true, message: "请输入", trigger: "blur" }],
    loadType: [{ required: true, message: "请输入", trigger: "blur" }],
    value: [{ required: true, message: "请输入", trigger: "blur" }],
    userGroupValue: [{ required: true, message: "请输入", trigger: "blur" }],
    formulaCoefficient: [{ required: true, message: "请输入", trigger: "blur" }]
  };
  @Provide() private isGetLoadAttrsActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private userGroupOptions: any = [];

  private created() {
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getBasicLoadAttrs();
    this.getLoadAttrsAction();
    this.getUserAttrsOption();
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getLoadAttrs();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getLoadAttrs();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getLoadAttrs();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getLoadAttrs();
  }

  private resetForm() {
    const ref: any = this.$refs["ruleForm"];
    ref.resetFields();
    this.ruleForm.loadType = "";
  }

  private showNewLoadAttr() {
    this.isEdit = false;
    this.resetForm();
    this.isShowNewLoadAttr = true;
  }

  private editLoadAttr(row: any) {
    this.onEditRow = row;
    this.isEdit = true;
    this.ruleForm.name = row.name;
    this.ruleForm.desc = row.describe;
    this.ruleForm.loadType = row.attrtype;
    this.ruleForm.value = row.value;
    this.ruleForm.userGroupValue = row.userattr;
    if (this.ruleForm.loadType === 2) {
      this.ruleForm.formulaCoefficient = row.rate;
    }
    this.isShowNewLoadAttr = true;
  }

  private submitForm() {
    const ref: any = this.$refs["ruleForm"];
    ref.validate((valid: any) => {
      if (valid) {
        this.saveLoadAttr();
      } else {
        return false;
      }
    });
  }

  private getUserAttrsOption() {
    let request: any = new GetUserAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getUserAttrsOption(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.userGroupOptions = data.listList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private getBasicLoadAttrsFuc(data: any) {
    if (data.listList) {
      this.formulaOptions = data.listList;
    }
  }
  private getBasicLoadAttrs() {
    let request: any = new GetBasicLoadAttrsReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    ticketClient.getBasicLoadAttrs(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getBasicLoadAttrsFuc;
          handleResponse(data, _fuc);
          // if (!data.commonout || (data.commonout.code == 0)) {
          //   if (data.listList) {
          //     this.formulaOptions = data.listList;
          //   }
          // } else {
          //   this.$message.error(data.commonout.errmsg);
          // }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  private getLoadAttrsAction() {
    this.isGetLoadAttrsActionDone = true;
    this.pageIndex = 1;
    this.getLoadAttrs();
  }
  private getLoadAttrsFuc(data: any) {
    this.pagerCount = data.pageout.total;
    data.listList.forEach((item: any) => {
      item.newTime = timeFormat(item.utime);
      if (item.attrtype == 2) {
        this.formulaOptions.forEach((i: any) => {
          if (item.value == i.value) {
            item.newValue = i.name;
          }
        });
      } else {
        item.newValue = item.value;
      }
    });
    if (data.listList) {
      this.resultData = data.listList;
    }
  }
  private getLoadAttrs() {
    let request: any = new GetLoadAttrsReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setName(this.filterText);
    ticketClient.getLoadAttrs(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getLoadAttrsFuc;
          handleResponse(data, _fuc);
          // if (!data.commonout || (data.commonout.code == 0)) {
          //   this.pagerCount = data.pageout.total;
          //   data.listList.forEach((item: any) => {
          //     item.newTime = timeFormat(item.utime);
          //     if (item.attrtype == 2) {
          //       this.formulaOptions.forEach((i: any) => {
          //         if (item.value == i.value) {
          //           item.newValue = i.name;
          //         }
          //       });
          //     } else {
          //       item.newValue = item.value;
          //     }
          //   });
          //   if (data.listList) {
          //     this.resultData = data.listList;
          //   }
          // } else {
          //   this.$message.error(data.commonout.errmsg);
          // }
        }
        if (err) {
          errorMsg(err);
        }
        this.isGetLoadAttrsActionDone = false;
      }
    );
  }

  private saveLoadAttrFuc(data: any) {
    this.$message({
      message: "submit successfully",
      type: "success"
    });
    this.getLoadAttrs();
    this.resetForm();
    this.isShowNewLoadAttr = false;
  }
  private saveLoadAttr() {
    let request: any = new SaveLoadAttrReq();
    let loadItem: any = new LoadAttrItem();
    loadItem.setName(this.ruleForm.name);
    loadItem.setDescribe(this.ruleForm.desc);
    loadItem.setValue(this.ruleForm.value);
    loadItem.setAdminuid(Number(this.userId));
    loadItem.setAttrtype(Number(this.ruleForm.loadType));
    loadItem.setUserattr(this.ruleForm.userGroupValue);
    if (this.ruleForm.loadType === 2) {
      loadItem.setRate(Number(this.ruleForm.formulaCoefficient));
    }
    if (this.isEdit) {
      loadItem.setId(this.onEditRow.id);
      loadItem.setAttrid(this.onEditRow.attrid);
      loadItem.setCtime(this.onEditRow.ctime);
      loadItem.setUtime(this.onEditRow.utime);
    }
    request.setCommonin(setCommon());
    request.setData(loadItem);
    ticketClient.saveLoadAttr(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          this.isEdit = false;
          let _fuc = this.saveLoadAttrFuc;
          handleResponse(data, _fuc);
          // if (!data.commonout || (data.commonout.code == 0)) {
          //   this.$message({
          //     message: "提交成功",
          //     type: "success"
          //   });
          //   this.getLoadAttrs();
          //   this.resetForm();
          //   this.isShowNewLoadAttr = false;
          // } else {
          //   this.$message.error(data.commonout.errmsg);
          // }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
}
